import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import PepPrice, { PepPriceProps } from './PepPrice'

interface PepPriceContentfulFields {
  entryTitle?: string
  headingPriceSection?: string
  incaTrackingCode?: string
  priceTextSize?: string
  priceSignDirection?: string
  upfrontPriceText?: string
  monthlyPriceText?: string
  upfrontLegalText?: string
  monthlyLegalText?: string
  upfrontBottomText?: string
  monthlyBottomText?: string
  legalCalloutBanner?: string
  retailPriceLabel?: string
  ctaText?: string
  ctaLink?: string
  preOrderCTAText?: string
  preOrderCTALink?: string
  notificationTextContent?: string
  tooltipTextContent?: string
  stickyPriceBarEnabled?: boolean
  priceSectionEnabled?: boolean
  disabledPriceText?: string
  errorCardMessage?: string
  errorButtonText?: string
}

const ContentfulPepPrice = withContentful<PepPriceContentfulFields, PepPriceProps>(PepPrice, {
  entryTitle: (props) => props.fields.entryTitle,
  headingPriceSection: (props) => props.fields.headingPriceSection,
  incaTrackingCode: (props) => props.fields.incaTrackingCode,
  priceTextSize: (props) => props.fields.priceTextSize,
  priceSignDirection: (props) => props.fields.priceSignDirection,
  upfrontPriceText: (props) => props.fields.upfrontPriceText,
  monthlyPriceText: (props) => props.fields.monthlyPriceText,
  upfrontLegalText: (props) => props.fields.upfrontLegalText,
  monthlyLegalText: (props) => props.fields.monthlyLegalText,
  upfrontBottomText: (props) => props.fields.upfrontBottomText,
  monthlyBottomText: (props) => props.fields.monthlyBottomText,
  legalCalloutBanner: (props) => props.fields.legalCalloutBanner,
  retailPriceLabel: (props) => props.fields.retailPriceLabel,
  ctaText: (props) => props.fields.ctaText,
  ctaLink: (props) => props.fields.ctaLink,
  preOrderCTAText: (props) => props.fields.preOrderCTAText,
  preOrderCTALink: (props) => props.fields.preOrderCTALink,
  notificationTextContent: (props) => props.fields.notificationTextContent,
  tooltipTextContent: (props) => props.fields.tooltipTextContent,
  stickyPriceBarEnabled: (props) => props.fields.stickyPriceBarEnabled,
  priceSectionEnabled: (props) => props.fields.priceSectionEnabled,
  disabledPriceText: (props) => props.fields.disabledPriceText,
  errorCardMessage: (props) => props.fields.errorCardMessage,
  errorButtonText: (props) => props.fields.errorButtonText,
})

export default ContentfulPepPrice
